export const TRENDRADAR = 'trendradar'
export const RECOMMENDATIONS = 'recommendations'
export const CRITERIA = 'criteria'
